import { env } from '../../config';
import { bizRequest } from "../../bizClient"; // Import the API helper
// import { Context } from "../Context"; // Import context to get token
// import { useContext } from "react";
import constants from './constants.json';

const getBasePlaylists = async (customerId, userId, screenType, excludeScreenType) => {
    let url = userId ? `/api/playlists/getBasePlaylists/${customerId}/${userId}` : `/api/playlists/getBasePlaylists/${customerId}`
    const params = new URLSearchParams();
    if (screenType) params.append('screenType', screenType);
    if (excludeScreenType) params.append('excludeScreenType', excludeScreenType);
    if (params.toString()) url += `?${params.toString()}`;
    const playlists = await bizRequest(url)
    .then(data => {
        return data.map(d => {
            if (d.playlist.product === 'screen' || d.playlist.product === 'screen_pro') {
                return {
                    ...d.playlist,
                    devices: d?.devices,
                    location: d.location,
                    url: d?.slide?.url
                }
            }
            return;
        }).filter(n => n)
    })
    return playlists
}

const getTimezone = async (lat, long) => {
    const timezone = await fetch(`https://timezones.transitscreen.io/getTimezoneByCoordinates.php?apiKey=${env.TIMEZONE_API_KEY}&lat=${lat}&lon=${long}`)
    .then(response => response.json())
    .then(data => data.tzid);

    return timezone;
}

const getContentPlaylists = async (customerId) => {
    return await bizRequest(`/api/playlists/getContentPlaylists/${customerId}`)
    .then(data => {
        return data
    })
    .catch((error) => {
        console.error('Something went wrong:', error);
    });
}

const savePlaylist = async (state, customer) => {
    const tempInteractivityConfigs = {
        ...state.playlist.interactivityConfigs
     };

    // Remove dependent keys for bar and menu
    // If nav bar is not enabled, remove bar position
    if (!tempInteractivityConfigs?.navBarEnabled) {
        delete tempInteractivityConfigs.barPosition;
    }
    // If menu is not enabled, remove menu value
    if (!tempInteractivityConfigs?.menuEnabled) {
        delete tempInteractivityConfigs.menu;
    }

    const playlist = {
        ...state.playlist,
        interactivityConfigs: tempInteractivityConfigs,
        language: state?.playlist?.language,
        updatedBy: customer?.name
    }

     //Determine if url should save with coordinates, or locationCode
    let url = playlist.locationType === 'locationCode'
    ?`${env.CITYMO_URL}/?key=${customer?.apiKey || 'kDgUcNxt25pUpxy8ivQ5UYSvXc4dF0acwzLCLu3wMHa0rDZLGDcm3rsZ2LlMjsjs'}&locationCode=${playlist?.locationCode}`
    : `${env.CITYMO_URL}/?key=${customer?.apiKey || 'kDgUcNxt25pUpxy8ivQ5UYSvXc4dF0acwzLCLu3wMHa0rDZLGDcm3rsZ2LlMjsjs'}&coordinates=${playlist?.latitude},${playlist?.longitude}`;

    const urlColumns = ['brandingConfigs', 'interactivityConfigs', 'transportationConfigs'];

    for (const col of urlColumns) {
        const keyValues = playlist[col];
        for (const key in keyValues) {
          url += `&${key}=${keyValues[key]}`;
        }
    }
 
    //Add langauge value
    url += `&lang=${state?.playlist?.language}`;

    //Add geolocation only if it is needed
    if(state?.playlist?.geolocation === true) {
        url+= `&geolocation=${state?.playlist?.geolocation}`;
    }

    //Special case where transportation config affects columns in the playlist table
    playlist.isInteractive = playlist?.interactivityConfigs?.interactive ?? constants.DEFAULT_INTERACTIVITY_CONFIGS.interactive;

    //Create or update depending on playlist
    const bizUrl = playlist?.id 
    ? `/api/playlists/savePlaylist`
    : `/api/playlists/createBasePlaylist`
   
    return await bizRequest(bizUrl, 'POST', { 'Content-Type': 'application/json' }, {
        url: playlist.product === 'screen_pro' ? playlist.url : url,
        playlist: playlist
    })
    .then(resp => {
        return resp
    })
    .catch((error) => {
        console.error(error);
    });
}

const syncWithMonolith = async (state) => {
    let playlist = state.playlist;
    if (playlist?.id && playlist.product === 'screen_pro' && playlist.tsDeviceId) {
        const bizUrl = `/api/playlists/syncWithMonolith`;

        return await bizRequest(bizUrl, 'POST', { 'Content-Type': 'application/json' }, {
            playlist: state.playlist,
            defaultConfigs: {brandingConfigs: constants.DEFAULT_BRANDING_CONFIGS}
        })
        .then(resp => {
            return resp
        })
        .catch((error) => {
            console.error(error);
        });
    }
}

const syncRelatedPlaylists = async(state) => {
    let playlist = state.playlist;
    const url = `/api/playlists/syncRelatedPlaylists`;

    return await bizRequest(url, 'POST', { 'Content-Type': 'application/json' }, {
        playlist: playlist
    })
    .then(resp => {
        return resp;
    })
    .catch(error => {
        return error
    });
}

const updatePlaylistVersion = async (playlistId) => {
    const url = `/api/playlists/updatePlaylistVersion`;

    return await bizRequest(url, 'POST', { 'Content-Type': 'application/json' }, {
        id: playlistId
    })
    .then(resp => {
        return resp;
    })
    .catch(error => {
        return error
    });    
}

// screenType: string | undefined/null
// purchasedProducts: object
const isProductPurchased = (screenType, purchasedProducts) => {
    const requiredProduct = constants.SCREEN_TYPE_PRODUCT_MAP[screenType];

    if (!requiredProduct) return true; // No specific purchase required

    if (!purchasedProducts || Object.keys(purchasedProducts).length === 0) return false;
    return !!purchasedProducts?.[requiredProduct];
}

const getSlideById = async (slideId) => {
    return await bizRequest(`/api/slides/${slideId}`)
    .then(data => {
        return data
    })
    .catch((error) => {
        console.error('Something went wrong:', error);
        throw error;
    });
}

const getUserPermission = (subscriptionName, location, permissions) => {
    return subscriptionName in permissions && location.id in permissions[subscriptionName]
        ? permissions[subscriptionName][location.id]
        : [];
}

const userHasPermissionForLocation = (product, permissions, locationId) => {
    return Object.keys(permissions).includes(product)
        && locationId
        && locationId in permissions[product];
}

export {
    getBasePlaylists,
    getTimezone,
    getContentPlaylists,
    savePlaylist,
    updatePlaylistVersion,
    isProductPurchased,
    syncWithMonolith,
    syncRelatedPlaylists,
    getSlideById,
    userHasPermissionForLocation
}
